// @flow
import classnames from 'classnames';
import React, { useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Typography from '@material-ui/core/Typography';

import AvaMagnifyingLogoIcon from '../../components/Icons/AvaMagnifying';

import RoundedButton from '../../components/Buttons/RoundedButton';
import SearchAvaRoomInput from '../../components/JoinConversation/SearchAvaRoomInput';
import PhraseMarkdownText from '../../components/PhraseMarkdownText';

const useStyles = makeStyles(theme => ({
  button: {
    position: 'relative',
    width: '100%',
    height: 54,
    paddingTop: 0,
    paddingRight: 20,
    paddingBottom: 0,
    paddingLeft: 20,
  },
  label: {
    display: 'flex',
  },
  focused: {
    border: `1px solid ${theme.palette.ava.blue2}`,
    boxShadow: '0px 0px 0px 4px rgba(3, 132, 198, 0.12)',
  },
  icon: {
    position: 'absolute',
    top: 10,
    left: 20,
  },
  search: {
    flex: 1,
  },
  cursor: {
    marginLeft: 20,
  },
}));

const Placeholder = ({ innerProps, selectProps }) => {
  const theme = useTheme();

  return (
    <Typography
      color="textSecondary"
      style={{
        color: theme.palette.ava.blue2,
        fontSize: 20,
        left: 2,
        marginLeft: selectProps.autoFocus ? 16 : 30,
        overflow: 'hidden',
        position: 'absolute',
        width: `calc(100% - ${selectProps.autoFocus ? 16 : 30}px)`,
        textAlign: selectProps.autoFocus ? 'left' : 'center',
      }}
      {...innerProps}
      noWrap
    >
      {selectProps.autoFocus ? (
        <PhraseMarkdownText phraseKey="joinConversation.enterAvaUsername" />
      ) : (
        <PhraseMarkdownText phraseKey="sidebar.buttons.joinAConversation" />
      )}
    </Typography>
  );
};

const ValueContainer = ({ children, selectProps }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexWrap: 'wrap',
        maxWidth: 170,
        height: 50,
        marginLeft: selectProps.autoFocus ? 16 : 40,
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
  );
};

const JoinConversationButton = () => {
  const classes = useStyles();

  const [buttonClicked, setButtonClicked] = useState(false);

  return (
    <ClickAwayListener onClickAway={() => setButtonClicked(false)}>
      <Box>
        <RoundedButton
          className={classnames(classes.button, {
            [classes.focused]: buttonClicked,
          })}
          buttonClasses={{ label: classes.label }}
          color="white"
          onClick={() => setButtonClicked(true)}
          disableRipple
        >
          <div className={classes.icon}>
            <AvaMagnifyingLogoIcon width={28} height={28} />
          </div>
          <SearchAvaRoomInput
            className={classnames(classes.search, { [classes.cursor]: buttonClicked })}
            roomComponents={{
              Placeholder,
              ValueContainer,
            }}
            autoFocus={buttonClicked}
          />
        </RoundedButton>
      </Box>
    </ClickAwayListener>
  );
};

export default JoinConversationButton;
